export default Object.freeze({
  reCaptchaV2: {
    siteKey: undefined as string | undefined,
  },
});
